import React from 'react';
export function ZoomInIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7 20.3l-5.39-5.39a8.06 8.06 0 10-1.42 1.41l5.39 5.4a.999.999 0 001.42 0 1 1 0 000-1.42zM5.75 14.24a6 6 0 118.49-8.48 6 6 0 01-8.49 8.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9h-2V7a1 1 0 00-2 0v2H7a1 1 0 000 2h2v2a1 1 0 102 0v-2h2a1 1 0 000-2z"
  }));
}